export function jqSidebar() {
  
  jQuery(function () {

    const wrapRow = document.querySelector('.l-wrapRow');
    if(wrapRow) {

      var $window = $(window);
      var $header = $('.l-header');
      var $sidebar = $('.l-wrapRow_side_list');
      var $main = $('.l-wrapRow_main');
      //var $container = $('.l-wrapRow');

      var headerHeight = $header.outerHeight();

      $window.on('scroll resize', function() {
        var scrollY = $window.scrollTop();
        var mainTop = $main.offset().top;
        var mainHeight = $main.outerHeight();
        var sidebarHeight = $sidebar.outerHeight();
        //var containerLeft = $container.offset().left;
        var mainWidth = $main.outerWidth();

        if(scrollY >= mainTop - headerHeight && scrollY < mainTop + mainHeight - sidebarHeight) {
          if(!$sidebar.hasClass('is-fixed')) {
            $sidebar.addClass('is-fixed');
          }
          $sidebar.css({
            'top': headerHeight + 'px',
            //'left': (containerLeft + mainWidth) + 'px',
            'width': $sidebar.outerWidth() + 'px'  // 固定時の幅維持
          });
        } else {
          if($sidebar.hasClass('is-fixed')) {
            $sidebar.removeClass('is-fixed');
            $sidebar.css({
              'top': '',
              //'left': '',
              'width': ''
            });
          }
        }
      });


      //current

      var $window = $(window);
      var $header = $('.l-header');
      var headerHeight = $header.outerHeight();

      var $sections = $('.l-wrapRow_main section[id]');
      var $links = $('.l-wrapRow_side_list a');

      function updateCurrentLink() {
        var scrollY = $window.scrollTop() + headerHeight + 1; // 余裕を持たせるため+1px

        var currentId = null;

        $sections.each(function() {
          var $sec = $(this);
          var secTop = $sec.offset().top;
          var secHeight = $sec.outerHeight();

          if(scrollY >= secTop && scrollY < secTop + secHeight) {
            currentId = $sec.attr('id');
            return false; // 条件に合う最初のsectionでループ終了
          }
        });

        if(currentId) {
          $links.removeClass('current');
          $links.filter('[href="#' + currentId + '"]').addClass('current');
        } else {
          $links.removeClass('current');
        }
      }

      $window.on('scroll resize', updateCurrentLink);

      // 初期呼び出し
      updateCurrentLink();

      //sp
      if(window.matchMedia('(min-width:769px)').matches) {
  
      }

    }
  });

}